module.exports = __webpack_public_path__ + "img/tang-pineapple.aec4a61e.jpg";